import { AfterViewInit, Component, ElementRef, input, viewChild } from '@angular/core';
import { MatExpansionModule, MatExpansionPanel, MatExpansionPanelTitle } from '@angular/material/expansion';

@Component({
  selector: 'app-dropdown',
  imports: [MatExpansionPanel, MatExpansionPanelTitle, MatExpansionModule],
  templateUrl: './dropdown.component.html',
  styleUrl: './dropdown.component.scss'
})
/**
 * Die Klasse 'DropdownComponent'-Klasse stellt ein Dropdown-Menü zur Verfügung.
 * BEGRÜNDUNG: Es gibt keine AFO die ein Dropdown-Menü für den TI-M vorschreibt.
 */
export class DropdownComponent implements AfterViewInit {
  label = input<string>('');
  dataTestId = input<string>('');
  dropdownDataTestId = input<string>('');
  collapsed = input<boolean>();
  orgAdmin = input<boolean>();
  readonly panelEl = viewChild.required('panel', { read: ElementRef });
  protected readonly requestIdleCallback = requestIdleCallback;
  private readonly expansionPanel = viewChild.required(MatExpansionPanel);

  openPanel(): void {
    this.expansionPanel().open();
  }

  closePanel(): void {
    this.expansionPanel().close();
  }

  ngAfterViewInit(): void {
    // Workaround for setting panel minimum height
    this.expansionPanel().opened.subscribe(() => {
      const content = this.panelEl().nativeElement.querySelector('.mat-expansion-panel-body') as HTMLElement;
      requestAnimationFrame(() => {
        content.style.minHeight = '5rem';
      });
    });
  }
}
